export { UploadArea } from './upload-area';
